import { ApprovedTypesEnum } from 'APIPackage/KnmModule/enums/ApprovedTypesEnum';

import { IApprovedSelectOption } from '../interfaces/IApprovedSelectOption';

const approvedSelectOption: IApprovedSelectOption = {
  id: ApprovedTypesEnum.APPROVED,
  label: 'Согласовано',
  value: ApprovedTypesEnum.APPROVED,
};

export const onApprovalSelectOption: IApprovedSelectOption = {
  id: ApprovedTypesEnum.ON_APPROVAL,
  label: 'На согласовании',
  value: ApprovedTypesEnum.ON_APPROVAL,
};

const approvedWithRemarkSelectOption: IApprovedSelectOption = {
  id: ApprovedTypesEnum.APPROVED_WITH_REMARK,
  label: 'Согласовано с замечанием',
  value: ApprovedTypesEnum.APPROVED_WITH_REMARK,
};

export const approvedSelectOptions: IApprovedSelectOption[] = [
  approvedSelectOption,
  onApprovalSelectOption,
  {
    id: ApprovedTypesEnum.DENIED,
    label: 'Не согласовано',
    value: ApprovedTypesEnum.DENIED,
  },
];

export const approvedSelectOptionsOld: IApprovedSelectOption[] = [
  approvedSelectOption,
  onApprovalSelectOption,
  {
    id: ApprovedTypesEnum.DENIED,
    label: 'Отклонено',
    value: ApprovedTypesEnum.DENIED,
  },
];

const approvedChangeKnmSelectOption: IApprovedSelectOption = {
  id: ApprovedTypesEnum.APPROVED,
  label: 'Да',
  value: ApprovedTypesEnum.APPROVED,
};
const notApprovedChangeKnmSelectOption: IApprovedSelectOption = {
  id: ApprovedTypesEnum.DENIED,
  label: 'Нет',
  value: ApprovedTypesEnum.DENIED,
};

export const approvedChangeKnmSelectOptions: IApprovedSelectOption[] = [
  approvedChangeKnmSelectOption,
  notApprovedChangeKnmSelectOption,
];

export const planTypeApprovedSelectOptions: IApprovedSelectOption[] = [
  approvedSelectOption,
  approvedWithRemarkSelectOption,
  {
    id: ApprovedTypesEnum.DENIED,
    label: 'Исключено',
    value: ApprovedTypesEnum.DENIED,
  },
];

export const planTypeApprovedSelectRenamedOptions: IApprovedSelectOption[] = [
  approvedSelectOption,
  approvedWithRemarkSelectOption,
  {
    id: ApprovedTypesEnum.DENIED,
    label: 'Не согласовано',
    value: ApprovedTypesEnum.DENIED,
  },
];

export const planTypeRejectAppealedSelectOptions: IApprovedSelectOption[] = [
  approvedSelectOption,
  approvedWithRemarkSelectOption,
  {
    id: ApprovedTypesEnum.DENIED,
    label: 'Отклонено',
    value: ApprovedTypesEnum.DENIED,
  },
];

export const planFullListTypeApprovedSelectOptions: IApprovedSelectOption[] = [
  ...planTypeApprovedSelectOptions,
  onApprovalSelectOption,
  {
    id: ApprovedTypesEnum.DENIED_PLANNED,
    label: 'Исключено',
    value: ApprovedTypesEnum.DENIED_PLANNED,
  },
];

export const planFullListTypeApprovedSelectRenamedOptions: IApprovedSelectOption[] = [
  ...planTypeApprovedSelectRenamedOptions,
  onApprovalSelectOption,
  {
    id: ApprovedTypesEnum.DENIED_PLANNED,
    label: 'Исключено',
    value: ApprovedTypesEnum.DENIED_PLANNED,
  },
];
